import "babel-polyfill"
import Vue from 'vue'
import router from './routes/router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import store from '@/store/index'
import auth from './utils/auth'

import adminMenuService from '@/services/admin/AdminMenuService'
const getViewComponent = (path) => (resolve) => require(['@/views' + path + '.vue'], resolve)


Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


if (auth.getToken()) {
    adminMenuService.getCurrent().then(rs => {
        let data = rs.data;
        let level2Data = [];

        for (let i = 0; i < data.length; i++) {
            if (data[i].level == 2) {
                level2Data.push(data[i])
            }
        }
        for (let j = 0; j < level2Data.length; j++) {
            if (level2Data[j].url.indexOf("/list") > 0) {
                let addVue = level2Data[j].url.replace("list", "add"); //编辑模板
                router.options.routes[0].children.push({
                    path: level2Data[j].url,
                    component: getViewComponent(level2Data[j].url), //将组件用require引进来
                    meta: { title: level2Data[j].name + '-国华生命科技' }
                }, {
                    path: addVue,
                    component: getViewComponent(addVue),
                    meta: { title: level2Data[j].name + '-国华生命科技' }
                })
            } else {
                router.options.routes[0].children.push({
                    path: level2Data[j].url,
                    component: getViewComponent(level2Data[j].url), //将组件用require引进来
                    meta: { title: level2Data[j].name + '-国华生命科技' }
                })
            }
            router.addRoutes(router.options.routes);
        }
    })
}



// WEBPACK FOOTER //
// ./src/main.js